export default "__VITE_ASSET__CeBuZqMK__"